import { css } from '@emotion/core';
import { MEDIA_BREAKPOINTS } from '../../../../common/services/breakpoints';

export const licenseInformationDialogContainerCSS = css`
    height: 90vh;
    width: 90vw;
`;

export const licenseContainerCenterLabelCSS = css`
    display: flex;
    justify-content: center;
    padding-top: 1.5rem;
`;

export const licenseLoadingSpinnerCSS = css`
    display: flex;
    justify-content: center;
    padding-top: 2rem;
`;

export const licenseInformationContainerCSS = css`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
`;

export const licenseMiscInfoContainerCSS = ({ colors }) => css`
    outline: 1px solid ${colors.neutral80};
    border-radius: 0.5rem;
    padding: 0.625rem 0.625rem 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

export const licensePoolHelpTextDialogCSS = css`
    padding-left: 1rem;
    padding-right: 1rem;
    display: flex;
    flex-direction: column;
    font-size: 0.85rem;
`;

export const licenseMiscInfoSectionCSS = css`
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 1rem;

    ${MEDIA_BREAKPOINTS.SMALL_MAX} {
        flex-direction: column;
        gap: 0;
    }
`;

export const licenseMiscInfoColumnCSS = css`
    flex: 1;
    padding: 1rem 1rem 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

export const licenseMiscInfoRowCSS = css`
    display: flex;
    gap: 0.5rem;
`;

export const licenseMiscInfoRowTitleCSS = css`
    flex: 1;
    text-align: right;
    font-weight: bold;
`;

export const licenseMiscInfoRowLabelCSS = css`
    flex: 1;
    text-align: left;
`;

export const licenseDialogContentCSS = css`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding: 1rem;
`;

export const licenseSectionCSS = css`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

export const licenseRowContainerCSS = ({ colors }) => css`
    display: flex;
    overflow-x: auto;
    padding: 1.5rem;
    outline: 1px solid ${colors.neutral80};
    border-radius: 0.5rem;
    gap: 1.5rem;

    ${MEDIA_BREAKPOINTS.SMALL_MAX} {
        flex-direction: column;
        gap: 1rem;
    }
`;

export const toggleNoteLengthCSS = ({ colors }) => css`
    color: ${colors.blue60};
    cursor: pointer;
`;

export const licenseRowColumnCSS = css`
    width: 10rem;
    min-width: 6rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    height: 100% ${MEDIA_BREAKPOINTS.EXTRA_SMALL} {
        width: 100%;
    }
`;

export const licenseRowAppLabelColumnCSS = css`
    width: 10rem;
    min-width: 6rem;

    > span {
        font-weight: bold;
    }

    ${MEDIA_BREAKPOINTS.SMALL_MAX} {
        width: 100%;
    }
`;

export const licenseRowAppColumnContainerCSS = css`
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 1.5rem;

    ${MEDIA_BREAKPOINTS.EXTRA_SMALL} {
        flex-direction: column;
    }
`;

export const licenseRowTitleCSS = ({ colors }) => css`
    color: ${colors.textSecondary};
`;

export const licenseRowValueCSS = css`
    margin-top: auto;
`;
